<template>
  <div class="pw-field">
    <input
      :type="visible ? 'text' : 'password'"
      class="auth-input"
      :value="value"
      :autocomplete="autocomplete"
      :required="required"
      :minlength="minlength"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
    <button
      type="button"
      class="pw-toggle"
      :aria-label="visible ? 'Ocultar contraseña' : 'Mostrar contraseña'"
      @click="visible = !visible"
    >
      <svg v-if="!visible" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path
          d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.8" />
      </svg>
      <svg v-else viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path
          d="M6.6 6.6C3.4 8.5 1.5 12 1.5 12s3.5 7 10.5 7a10.4 10.4 0 0 0 4.2-.9M10.6 5.2A10.6 10.6 0 0 1 12 5c7 0 10.5 7 10.5 7a13.5 13.5 0 0 1-3.1 4.1"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 9.9A3 3 0 0 0 12 15a3 3 0 0 0 2.1-.9"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "PasswordField",
  props: {
    value: { type: String, default: "" },
    autocomplete: { type: String, default: "current-password" },
    required: { type: Boolean, default: true },
    minlength: { type: [String, Number], default: null },
    placeholder: { type: String, default: "" },
  },
  data() {
    return { visible: false };
  },
};
</script>

<style scoped>
.pw-field {
  position: relative;
}
.auth-input {
  box-sizing: border-box;
  width: 100%;
  height: 52px;
  padding: 0 46px 0 16px;
  border: 1px solid #d5d9e0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  font: 15px "IBM Plex Sans", sans-serif;
  color: #1c2434;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.auth-input::placeholder {
  color: #9aa1ae;
}
.auth-input:hover {
  border-color: #b9bfcb;
}
.auth-input:focus {
  outline: none;
  border-color: #c9963a;
  box-shadow: 0 0 0 4px rgba(201, 150, 58, 0.18);
}
.pw-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  border: none;
  background: none;
  padding: 4px;
  color: #5b6070;
  cursor: pointer;
  display: flex;
}
.pw-toggle:hover {
  color: #222a47;
}
</style>
